import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { toast } from 'sonner'
import { supabaseApi } from '~/supabase/api'
import { FilterOperator, Visitor } from '~/supabase/types'

export const GET_VISITORS_QUERY_KEY = 'get-visitors'

export type GetVisitorFilters = Array<
  | {
      value: string | number | boolean
      column: keyof Visitor
      operator: FilterOperator
    }
  | { operator: 'range'; column: number; value: number }
>

export const useGetVisitors = (params?: {
  filters?: GetVisitorFilters
  /** Raw PostgREST `or` clause, e.g. `agency.ilike.%google%,agency.ilike.%instagram%`. */
  orFilter?: string
  keepPreviousData?: boolean
  enabled?: boolean
}) => {
  const { filters, orFilter, enabled } = params ?? {}

  return useQuery({
    queryKey: [GET_VISITORS_QUERY_KEY, filters, orFilter],
    queryFn: async () => {
      const visitorsTable = supabaseApi.from('visitors').select('*')

      const filtered = filters
        ? filters.reduce((acc, { value, column, operator }) => {
            if (operator === 'range') {
              return acc.range(column, value)
            }
            // @ts-expect-error type casting required here as (column:string,value:any)=> typeof visitorsTable
            return acc[operator](column, value)
          }, visitorsTable)
        : visitorsTable

      const promise = orFilter ? filtered.or(orFilter) : filtered

      const { data, error } = await promise.order('id', { ascending: false })

      if (error) {
        toast.error(error.message)
        throw error
      }
      return data
    },
    placeholderData: params?.keepPreviousData ? keepPreviousData : undefined,
    enabled,
    refetchInterval: 10 * 60 * 1000,
  })
}
